module.exports = __webpack_public_path__ + "media/images/icons/chat-minimize-118be4a062f8735e25b03aa4ff951459.svg";